<template>
  <div
    v-infinite-scroll="getMoreItems"
    infinite-scroll-disabled="busy"
    infinite-scroll-distance="10"
    infinite-scroll-immediate-check="false"
  >
    <div
      v-if="loading"
      class="text-xs-center"
    >
      <v-progress-circular
        indeterminate
        color="primary"
      />
    </div>
    <div
      v-if="isListEmpty && !loading && emptyMarkEnable"
      id="selected-products-empty"
    >
      <v-icon style="font-size:100px;">
        error_outline
      </v-icon>
      <p id="selected-products-empty-title">
        {{ $t("newLP.emptyList") }}
      </p>
    </div>
    <v-data-iterator
      :items="itemList"
      no-data-text=""
      hide-actions
      content-tag="v-layout"
      align-start
      expand
      loading
      select-all="red"
      wrap
    >
      <v-flex
        slot="item"
        slot-scope="props"
        :class="flexClass"
        v-bind="{
          [`xs${listBreakPoint.xs}`]: true,
          [`sm${listBreakPoint.sm}`]: true,
          [`md${listBreakPoint.md}`]: true,
          [`lg${listBreakPoint.lg}`]: true,
          [`xl${listBreakPoint.xl}`]: true
        }"
        style="position: relative; padding:15px !important;"
      >
        <img
          v-if="props.item.recent && !props.item['orderCode']"
          :src="flagImg.src"
          :style="flagImg.style"
        >
        <licenseproduct-cards
          v-if="modelName === 'licensedproducts'"
          :item="props.item"
          :img="props.item.images[0].image?props.item.images[0].image.thumbnail:getThumbnailImage(props.item)"
          :hash="props.item.images[0].image_hash"
          :is-related-card="isRelatedCard"
          :list-layout="cardLayout"
        />
        <pinkfongproduct-cards
          v-else-if="modelName === 'pinkfongproducts'"
          :item="props.item"
          :img="props.item.images[0].image?props.item.images[0].image.thumbnail:getThumbnailImage(props.item)"
          :hash="props.item.images[0].image_hash"
          :is-related-card="isRelatedCard"
          :list-layout="cardLayout"
        />
        <card
          v-else
          :img="props.item.images[0].image?props.item.images[0].image.thumbnail:getThumbnailImage(props.item)"
          :hash="props.item.images[0].image_hash"
          :type="modelName"
        >
          <slot :item="props.item" />
        </card>
      </v-flex>
    </v-data-iterator>
    <v-layout
      v-if="busy"
      row
      justify-center
    >
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
        class="my-4"
      />
    </v-layout>
  </div>
</template>

<script>
import infiniteScroll from 'vue-infinite-scroll'
import Card from 'components/Card.vue'
import LicenseProductCard from '../app/contents/LicenseProductCard.vue'
import PinkfongProductCard from '../app/contents/PinkfongProductCard.vue'

export default {
  directives: { infiniteScroll },
  components: {
    'card': Card,
    'licenseproduct-cards': LicenseProductCard,
    'pinkfongproduct-cards': PinkfongProductCard
  },
  props: {
    items: {
      type: Array,
      default: this.getInitialItems
    },
    modelName: {
      type: String,
      default: ''
    },
    itemsUrl: {
      type: String,
      default: ''
    },
    params: {
      type: Object,
      default: () => {}
    },
    isSelect: {
      type: Boolean,
      default: false
    },
    cardLayout: {
      type: String,
      default: 'card'
    },
    flexClass: {
      type: String,
      default: ''
    },
    listBreakPoint: {
      type: Object,
      default: () => {}
    },
    isRelatedCard: {
      type: Boolean,
      default: false
    },
    emptyMarkEnable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      itemList: [],
      nextLink: undefined,
      busy: false,
      loading: true,
      flagImg: {
        src: '',
        style: ''
      }
    }
  },
  computed: {
    isListEmpty: function () {
      if (!this.itemList || this.itemList === undefined) return false

      if (this.itemList.length === 0) return true

      return false
    }
  },
  watch: {
    'items' () {
      this.initListItem()
    },
    '$route.params' () {
      window.scrollTo(0, 0)
      this.$data.itemList = []
      this.nextLink = undefined
      this.busy = false
      this.initListItem()
    },
    '$store.getters.getFilterParams' () {
      this.$nextTick(() => {
        this.getUpdatedFilterItems()
      })
    }
  },
  created () {
    window.addEventListener('resize', this.onResize)
  },
  destroyed () {
    this.$store.commit('listDeleted')
    window.removeEventListener('resize', this.onResize)
  },
  beforeMount () {
    this.initListItem()
  },
  mounted () {
    const filterParams = { ...this.$store.getters.getFilterParams }

    if (this.$store.getters.isListDeleted && Object.keys(filterParams).length > 0) {
      this.getUpdatedFilterItems()
    }
    this.onResize()
  },
  methods: {
    onResize () {
      // if (window.innerWidth >= 1264 && (this.modelName === 'licensedproducts' || this.modelName === 'pinkfongproducts')) {
      //   this.flagImg.src = require('../assets/new_tag_l.png')
      //   this.flagImg.style = 'position: absolute; right: 24px; width:92px; z-index:1;'
      // } else {
      //   this.flagImg.src = require('../assets/new_tag_s.png')
      //   this.flagImg.style = 'position: absolute; left: 15px; width:20%; max-width:70px; z-index:1;'
      // }

      this.flagImg.src = require('../assets/new_tag_s.png')
      this.flagImg.style = 'position: absolute; left: 15px; width:20%; max-width:70px; z-index:1;'
    },
    initListItem () {
      this.loading = true
      this.getInitialItems()
    },
    getInitialItems () {
      if (this.items !== undefined) {
        this.itemList = this.items
        this.loading = false
      }
    },
    getUpdatedFilterItems () {
      this.$store.commit('listRepaired')
      const filterParams = this.$store.getters.getFilterParams
      const newParams = {
        ...this.$route.params,
        ...filterParams
      }

      delete newParams['selected']

      if (this.items !== undefined) {
        this.itemList = this.items
        this.loading = false
        return
      }

      window.scrollTo(0, 0)
      this.loading = true
      this.$http.get(this.itemsUrl, { params: newParams })
        .then(response => {
          this.itemList = response.data.results
          this.nextLink = response.data.next
          this.loading = false
        })
    },
    getMoreItems () {
      if (this.nextLink === null || this.nextLink === undefined) {
        return
      }
      this.busy = true
      this.$http.get(this.nextLink)
        .then(response => {
          if (response.request.responseURL === this.nextLink) {
            this.itemList = this.itemList.concat(response.data.results)
            this.nextLink = response.data.next
          }
          this.busy = false
        })
    },
    select (item) {
      item.product = this.modelName
      this.$store.commit('toggle', item)
    },
    getDetailUrl (item) {
      if (this.isSelect) {
        return '/' + this.$language.locale + '/' + item.product + '/' + encodeURIComponent(item.category.code) + '/' + item.code
      } else {
        let category = this.$route.params.category ? this.$route.params.category : 'all'
        return '/' + this.$language.locale + '/' + this.modelName + '/' + category + '/' + item.code
      }
    },
    getThumbnailImage (item) {
      const imageCode = {
        'mediacontent': 'video',
        'licensedproducts': 'licensed',
        'pinkfongproducts': 'product'
      }
      return `/api/images/${imageCode[item.product]}/${item.code}/`
    }
  }
}
</script>

<style>
.pretty input {
  height: 30px;
  width: 26px;
}
.inner-checkbox {
  font-size: 20px;
  position: absolute;
  height: 15px;
  top: 0;
  left: 0;
  margin: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/List.vue